import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
// Images
import bgImage from "assets/images/strategia.jpg";
//import mainos from "assets/images/JulisteA3.jpg";
import { Card, CardContent, Typography, Button } from "@mui/material";
//import { MenuItem } from "@mui/material";
import Strategycomments from "./Strategycomments";
import Budget from "./Budget";
import Focusareas from "./Focusareas";
import SWOT from "./SWOT";
import Kartta from "./Kartta";
import { useParams } from "react-router-dom";
//import ReactGA from "react-ga4";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
import { ALL_MUNICONFIG } from "../queries";
import { useQuery } from "@apollo/client";
//import LandCalculator from "./LandCalculator";
import { useTranslation } from "react-i18next";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Strategy = ({ selectedKunta, setError, selectKunta, selected, setSelected }) => {
  //const Strategy = ({ selectedKunta, selectKunta }) => {
  //const [t] = useTranslation("common");
  //ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID);
  const [t] = useTranslation("common");
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  //console.log(selectedKunta);
  //const [idea, setIdea] = useState("");
  const [municonfigs, setMuniconfigs] = useState([]);
  const [municonfig, setMuniconfig] = useState({});
  //const [t] = useTranslation("common");
  const municonfigss = useQuery(ALL_MUNICONFIG, {
    pollInterval: 1000000,
  });

  useEffect(() => {
    let municonfigsss = [];
    //let municipalitiess = [];
    if (municonfigss.data) {
      municonfigsss = municonfigss.data.allMuniconfigs;
      //setOrgans(organss);
      //console.log(municonfigsss);
      setMuniconfigs(municonfigsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
    ////console.log(localStorage.getItem("usertype"));
  }, [municonfigss]);

  useEffect(() => {
    let municonf = municonfigs.filter((a) => a.name === selectedKunta);
    //console.log(municonf[0]);
    if (municonf.length > 0) {
      //console.log("ok");
      setMuniconfig(municonf[0]);
    } else {
      setMuniconfig({ strategycommentcategories: "" });
    }
    //console.log(municonfig);
  }, [municonfigs, selectedKunta]);
  let muni = useParams().municipality;
  useEffect(() => {
    if (muni !== undefined) {
      selectKunta(muni);
    }
  }, [muni]);

  const addTool = () => {
    if (
      selected === "Kommentit" &&
      (municonfig.strategycomments || localStorage.getItem("usertype") === "3")
    ) {
      return (
        <Strategycomments
          setError={setError}
          selectedKunta={selectedKunta}
          categories={municonfig.strategycommentcategories}
        />
      );
    } else {
      if (
        selected === "Painopisteet" &&
        (municonfig.strategyfocusareas || localStorage.getItem("usertype") === "3")
      ) {
        return <Focusareas setError={setError} selectedKunta={selectedKunta} />;
      } else {
        if (
          selected === "SWOT" &&
          (municonfig.strategyswot || localStorage.getItem("usertype") === "3")
        ) {
          return <SWOT setError={setError} selectedKunta={selectedKunta} />;
        } else {
          if (
            selected === "Budjetointi" &&
            (municonfig.strategybudget || localStorage.getItem("usertype") === "3")
          ) {
            return <Budget setError={setError} selectedKunta={selectedKunta} />;
          } else {
            if (
              selected === "Kartta" &&
              (municonfig.strategymap || localStorage.getItem("usertype") === "3")
            ) {
              return <Kartta selectedKunta={selectedKunta} setError={setError} />;
            } else {
              return " ";
            }
          }
        }
      }
    }
  };
  const commentButton = () => {
    //console.log(municonfig);
    if (selected === "Kommentit" && municonfig.strategycomments) {
      return (
        <Button
          variant="contained"
          style={{ color: "black" }}
          onClick={() => setSelected("Kommentit")}
        >
          {t("strategy.comments")}
        </Button>
      );
    } else {
      if (municonfig.strategycomments || localStorage.getItem("usertype") === "3") {
        return (
          <Button
            variant="outlined"
            style={{ color: "black" }}
            onClick={() => setSelected("Kommentit")}
          >
            {t("strategy.comments")}
          </Button>
        );
      } else {
        return "";
      }
    }
  };
  const focusareaButton = () => {
    if (selected === "Painopisteet" && municonfig.strategyfocusareas) {
      return (
        <Button
          variant="contained"
          style={{ color: "black" }}
          onClick={() => setSelected("Painopisteet")}
        >
          {t("strategy.focusareas")}
        </Button>
      );
    } else {
      if (municonfig.strategyfocusareas || localStorage.getItem("usertype") === "3") {
        return (
          <Button
            variant="outlined"
            style={{ color: "black" }}
            onClick={() => setSelected("Painopisteet")}
          >
            {t("strategy.focusareas")}
          </Button>
        );
      } else {
        return " ";
      }
    }
  };
  const swotButton = () => {
    if (selected === "SWOT" && municonfig.strategyswot) {
      return (
        <Button variant="contained" style={{ color: "black" }} onClick={() => setSelected("SWOT")}>
          SWOT
        </Button>
      );
    } else {
      if (municonfig.strategyswot || localStorage.getItem("usertype") === "3") {
        return (
          <Button variant="outlined" style={{ color: "black" }} onClick={() => setSelected("SWOT")}>
            SWOT
          </Button>
        );
      } else {
        return " ";
      }
    }
  };
  const budgetButton = () => {
    if (selected === "Budjetointi" && municonfig.strategybudget) {
      return (
        <Button
          variant="contained"
          style={{ color: "black" }}
          onClick={() => setSelected("Budjetointi")}
        >
          {t("strategy.budget")}
        </Button>
      );
    } else {
      if (municonfig.strategybudget || localStorage.getItem("usertype") === "3") {
        return (
          <Button
            variant="outlined"
            style={{ color: "black" }}
            onClick={() => setSelected("Budjetointi")}
          >
            {t("strategy.budget")}
          </Button>
        );
      } else {
        return " ";
      }
    }
  };
  const mapButton = () => {
    if (selected === "Kartta" && municonfig.strategymap) {
      return (
        <Button
          variant="contained"
          style={{ color: "black" }}
          onClick={() => setSelected("Kartta")}
        >
          {t("strategy.map")}
        </Button>
      );
    } else {
      if (municonfig.strategymap || localStorage.getItem("usertype") === "3") {
        return (
          <Button
            variant="outlined"
            style={{ color: "black" }}
            onClick={() => setSelected("Kartta")}
          >
            {t("strategy.map")}
          </Button>
        );
      } else {
        return " ";
      }
    }
  };
  if (
    (municonfig.name === undefined ||
      (!municonfig.strategycomments &&
        !municonfig.strategyfocuareas &&
        !municonfig.strategybudget &&
        !municonfig.strategymap &&
        !municonfig.strategyswot)) &&
    localStorage.getItem("usertype") !== "3"
  ) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Typography variant="body1" gutterBottom>
          {t("strategy.notinuse")}
        </Typography>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <div
          style={{
            left: "10px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
            backgroundColor: "white",
            borderRadius: 90,
            opacity: 0.7,
          }}
          height="20px"
        >
          <div style={divstyle}>
            <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          <div style={divstyle}>
            <FacebookMessengerShareButton
              url={shareUrl}
              appId="521270401588372"
              className="Demo__some-network__share-button"
            >
              <FacebookMessengerIcon size={32} round />
            </FacebookMessengerShareButton>
          </div>
          <div style={divstyle}>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <XIcon size={32} round />
            </TwitterShareButton>
          </div>
          <div style={divstyle}>
            <TelegramShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={32} round />
            </TelegramShareButton>
          </div>
          <div style={divstyle}>
            <WhatsappShareButton
              url={shareUrl}
              title={title}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
          </div>
          <div style={divstyle}>
            <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
          </div>
          <div style={divstyle}>
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body="body"
              className="Demo__some-network__share-button"
            >
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
          <div style={divstyle}>
            <InstapaperShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <InstapaperIcon size={32} round />
            </InstapaperShareButton>
          </div>
          <div style={divstyle}>
            <ThreadsShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <ThreadsIcon size={32} round />
            </ThreadsShareButton>
          </div>
        </div>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={16} lg={15} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="black"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {t("strategy.header")}: {selectedKunta}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <Card style={{ marginBottom: "1rem" }}>
                  <CardContent>
                    <Typography variant="body1" gutterBottom>
                      {t("strategy.text")}
                      <br />
                      <br />
                      {t("strategy.reference")}
                      <br />
                      <br />
                      <a
                        href="https://siikainen.fi/kunta-ja-hallinto/paatoksenteko/kuntastrategia/"
                        target="0"
                      >
                        Siikainen
                      </a>{" "}
                      <a
                        href="https://enontekio.fi/media/asiakirjat/kuntastrategia/strategia_2022_2025.pdf"
                        target="0"
                      >
                        Enontekiö
                      </a>{" "}
                      <a
                        href="https://hailuoto.fi/kuntastrategia-2023-2025/attachment/kuntastrategian-paivitys-vuosille-2023-2025/"
                        target="0"
                      >
                        Hailuoto
                      </a>{" "}
                      <a
                        href="https://cms.pori.fi/uploads/sites/2/2022/10/pori_2030_strategia_kv_11.4.2022.pdf"
                        target="0"
                      >
                        Pori
                      </a>{" "}
                      <a
                        href="https://www.tampere.fi/sites/default/files/2022-05/FINAL_Tampereen%20strategia%202030_saavutettava_0.pdf"
                        target="0"
                      >
                        Tampere
                      </a>{" "}
                      <a
                        href="https://www.hirvensalmi.fi/wp-content/uploads/2017/08/kuntastrategia-2023-2026-kv-23.5.2022.pdf"
                        target="0"
                      >
                        Hirvensalmi
                      </a>{" "}
                      <a
                        href="https://merikarvia.fi/wp-content/uploads/2022/06/Merikarvia_210x120mm_vedos.pdf"
                        target="0"
                      >
                        Merikarvia
                      </a>{" "}
                      <a
                        href="https://www.vehmaa.fi/client/vehmaa/userfiles/strategia-2021-2025-v3-valtuusto-29112021.pdf"
                        target="0"
                      >
                        Vehmaa
                      </a>{" "}
                      <a
                        href="https://www.turku.fi/sites/default/files/document/turku_kaupunkistrategia_ilman_mittareita.pdf"
                        target="0"
                      >
                        Turku
                      </a>{" "}
                      <br />
                      <br />
                      <div dangerouslySetInnerHTML={{ __html: municonfig.strategytext }} />
                      <br />
                      <br />
                      {commentButton()}
                      {focusareaButton()}
                      {swotButton()}
                      {budgetButton()}
                      {mapButton()}
                    </Typography>
                  </CardContent>
                </Card>
                {addTool()}
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};
export default Strategy;
